import Observer from "../classes/Observer.js";
import Store from "../classes/Store.js";

/**
 * The observer for game-wide events.
 * @type {Observer}
 */
export const gameObserver = Observer.create("game");

/**
 * The observer for token events.
 * @type {Observer}
 */
export const tokenObserver = Observer.create("token");

/**
 * The observer for log events.
 * @type {Observer}
 */
export const logObserver = Observer.create("log");

/**
 * The observer for info-token events.
 * @type {Observer}
 */
export const infoTokenObserver = Observer.create("info-token");

/**
 * The main store for the application.
 * @type {Store}
 */
export const mainStore = Store.create("pocket-grimoire");
